import { render, staticRenderFns } from "./FaltantesExport.vue?vue&type=template&id=482b608e"
import script from "./FaltantesExport.vue?vue&type=script&lang=js"
export * from "./FaltantesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports